// extracted by mini-css-extract-plugin
module.exports = {"content_wrapper":"content_wrapper__twkLi1Yq7reWQ","caption":"caption__PuFqJsKGmy+ES"};